import { FC } from 'react';
import { Icon, IconTypes } from '../../atoms';
import styles from './availability-item.module.scss';

export type AvailabilityItemProps = {
  itemText: string;
  icon: IconTypes;
};

export const AvailabilityItem: FC<AvailabilityItemProps> = ({itemText, icon}) => {
  return (
    <div className={styles.availabilityItem}>
      <span className={styles.iconWrapper}>
        <Icon icon={icon} size={'30px'} />
      </span>
      <span>{itemText}</span>
    </div>
  );
}